module.exports = __webpack_public_path__ + "img/doc.994bed46.svg";